import Vendor from 'nestedy';

export default function nestedy(element, options) {
  return new Vendor(element, {
    clear: (field) => field.type !== 'hidden',
    destroy: true,
    excludes: (field) => field.dataset.template === 'true' || field.className === 'message--error',
    ...options,
  });
}
